<div class="scheduler__footer-container">
    <ng-template #content>
        <transflo-scheduler-modal (closeModal)='closeModal($event)'>
        </transflo-scheduler-modal>
    </ng-template>

    <a class="scheduler__footer-add-event-btn" (click)="open(content)"><i
            class="scheduler__footer-add-event-icon far fa-calendar-plus pr-2"></i>
        <span class="scheduler__footer-add-event-text">Add Event</span>
    </a>
    <div class="scheduler__footer-graphic-line"></div>
</div>